import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { filter, Subject, Subscription, take } from "rxjs";

import { BandeauApplicationComponent, BarreNavigationComponent, ValBarreNavigationItem } from "../../../../../val-ammon-composants/val-composants-lib/src/public-api";
import { APrHabilitation, PermissionsService } from "../../../../../val-ammon-permissions/val-permissions-lib/src/public-api";
import { ServicesClientService } from "../../../../../val-ammon-services/val-services-lib/src/public-api";
import { ValApiResultat } from "../../../../../val-ammon-services/val-services-communs-lib/src/public-api";
import { parametresClient, ServicesParametresClient } from "../../../../../val-definitions-communes-lib/src/public-api";
import { CreerBarreNavigationItems, navigationItems } from "./DonneesNavigation";
import { ValAppSettingsService } from "../../../../../val-ammon-services/val-app-settings-lib/src/public-api";

//Composant vue principale
@Component(
	{
		selector: 'val-vue-principale',
		imports:
			[
				RouterOutlet,
				BandeauApplicationComponent,
				BarreNavigationComponent
			],
		templateUrl: './vue-principale.component.html',
		styleUrl: './vue-principale.component.scss'
	})
export class VuePrincipaleComponent implements OnInit, AfterViewInit, OnDestroy {
	//Création
	//  Paramètres
	//    permissionsService    : Service permissions
	//    servicesClientService : Service client services
	//    oAuthService          : Service d’authentification
	//    servicesParametresClient : Service paramètres client
	//    router                : Routeur
	constructor(private permissionsService: PermissionsService, private servicesClientService: ServicesClientService, private oAuthService: OAuthService,
		private appSettingsService: ValAppSettingsService, private servicesParametresClient: ServicesParametresClient, private router: Router) {
		this.navigationItems = [];
		this.authentifier = false;
		this.estInitialise = false;
		this.initialisationTermine$ = new Subject<void>();
		this.navigationSubscription = null;
	}

	//Barre de navigation
	@ViewChild("barreNavigation")
	public barreNavigation!: BarreNavigationComponent;

	@ViewChild("bandeauApplication")
	public bandeauApplication!: BandeauApplicationComponent;

	//Indique si l’utilisateur est authentifié
	public authentifier: boolean;

	//Indique si l’initialisation du contexte client est terminée
	public estInitialise: boolean;

	//Items de la barre de navigation
	public navigationItems: ValBarreNavigationItem[];

	//Commande de navigation vers l’écran « Mes abonnements », proposé dans le menu utilisateur
	public readonly navigationMesAbonnements: any[] = ["/main", {outlets: {page: ["abonnements"]}}];

	//Commande de navigation vers l’écran « Mes préférences », proposé dans le menu utilisateur
	public readonly navigationMesPreferences: any[] = ["/main", {outlets: {page: ["preferences"]}}];


	private initialisationTermine$: Subject<void>;

	//Abonnement aux fins de navigation
	private navigationSubscription: Subscription | null;

	//Initialise le composant
	//  Retourne
	//    Opération asynchrone
	public async ngOnInit(): Promise<void> {
		if (this.oAuthService.hasValidAccessToken()) {
			this.authentifier = true;

			await this.servicesParametresClient.ChargerParametresClient();
			await this.RecupererHabilitations();
		}

		this.initialisationTermine$.next();
		this.estInitialise = true;
	}

	//Récupère les habilitations
	private async RecupererHabilitations(): Promise<void> {
		let identifiantsDicosNavigation: string[];
		let valApiResultat: ValApiResultat<APrHabilitation[]>;

		try {
			identifiantsDicosNavigation = this.RetournerIdentifiantsDicosNavigation();

			valApiResultat = await this.permissionsService.RetournerHabilitations(identifiantsDicosNavigation);

			if (valApiResultat.status === "success")
				this.CreerItemBarreNavigation(valApiResultat.resultat!);
		}
		catch (erreur) {
		}
	}

	//Exécute les action après l’initialisation de la vue du composant
	public ngAfterViewInit(): void {
		this.initialisationTermine$.pipe(take(1)).subscribe(() => {
			queueMicrotask(() => {
				this.barreNavigation.navigationItems = this.navigationItems;
				this.barreNavigation.Initialiser();
				this.barreNavigation.Selectionner(0, null);
			});
		});

		//Le menu suit la page affichée, y compris quand la navigation vient d’une page (carte de l’accueil)
		this.navigationSubscription = this.router.events
			.pipe(filter((evenement) => evenement instanceof NavigationEnd))
			.subscribe(() => this.barreNavigation.SelectionnerPageAffichee());
	}

	//Libère les abonnements à la destruction du composant
	public ngOnDestroy(): void {
		this.navigationSubscription?.unsubscribe();
	}

	//Retourne les identifiants des dicos des items de la barre de navigation
	//  Retourne
	//    Les identifiants des dicos des items de la barre de navigation
	private RetournerIdentifiantsDicosNavigation(): string[] {
		let identifiantsDicosNavigation: string[];

		identifiantsDicosNavigation = [];

		for (const barreNavigationItem of navigationItems) {
			if (barreNavigationItem.dico)
				identifiantsDicosNavigation.push(barreNavigationItem.dico!);

			if (barreNavigationItem.commandes && barreNavigationItem.commandes.length > 0) {
				for (const commande of barreNavigationItem.commandes) {
					if (commande.dico)
						identifiantsDicosNavigation.push(commande.dico!);
				}
			}
		}

		return identifiantsDicosNavigation;
	}

	//Crée les items de la barre de navigation
	//  Paramètres
	//    habilitations : Données des habilitations
	private CreerItemBarreNavigation(habilitations: APrHabilitation[]): void {
		let creerBarreNavigationItems: CreerBarreNavigationItems;

		creerBarreNavigationItems = new CreerBarreNavigationItems(habilitations);

		this.navigationItems = creerBarreNavigationItems.Executer();
	}

	//Retourne l'URL de l'API manifest
	//  Retourne
	//    URL de l'API manifest
	public RetournerUrlApiManifest(): string | null {
		return this.appSettingsService.Configuration.UrlApi.EFact;
	}
	
	//Retourne le login de l’utilisateur
	public loginUtilisateur() : string
	{
		return parametresClient.loginUtilisateur;
	}
}
